<template>
	<el-dialog :title='title' :visible.sync="dialogVisible" width="30%" :before-close='close'
		:close-on-click-modal='false'>
		<el-form ref='refwhiteForm' :model="whiteForm" label-position="right" label-width="120px">
			<el-form-item label="类型" required v-if="activeTabName=='0'">
				<el-radio-group v-model="whiteForm.type">
					<el-radio label="0" border>个人白名单</el-radio>
					<el-radio label="1" border>全公司白名单</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="公司名称" required>
				<tz-autocomplete ref="ref_tz_autocomplete" :searchDataList='searchDataList' :option='option'
					@handleSelect='handleSelect'>
				</tz-autocomplete>
			</el-form-item>
			<el-form-item v-if="activeTabName=='0' && accountList.length" label="税源地" prop="">
				<el-select v-model="whiteForm.channel_account" filterable placeholder="请选择税源地">
					<el-option
						v-for="item in this.accountList"
						:key="item.id"
						:label="item.channel_name"
						:value="item.channel_account">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="姓名" required v-if="whiteForm.type!='1'&&activeTabName!='2'">
				<el-input v-model.trim="whiteForm.fullname" maxlength="20" placeholder="请输入姓名" class="item-name"
					clearable>
				</el-input>
			</el-form-item>
			<el-form-item label="身份证号" required v-if="whiteForm.type!='1'&&activeTabName!='2'">
				<el-input v-model.trim="whiteForm.id_number" minlength="18" maxlength="18" placeholder="请输入身份证号"
					class="item-name" clearable>
				</el-input>
			</el-form-item>
			<el-form-item>
				<el-button type='primary' @click="addWhiteList">添加白名单</el-button>
			</el-form-item>
		</el-form>
	</el-dialog>
</template>

<script>
	import tzAutocomplete from '@/components/tz-autocomplete.vue'

	export default {
		props: {
			searchDataList: Array,
			activeTabName: String,
		},
		components: {
			tzAutocomplete
		},
		data() {
			return {
				dialogVisible: false,
				title: '',
				whiteForm: {
					fullname: '',
					id_number: '',
					company_id: '',
					type: '0'
				},
				accountList:[],
				option: {
					valueKey: 'name'
				}
			}
		},
		watch: {

		},
		methods: {
			// 银行账户列表
			async subAccount(id) {
				this.accountList = []
				let result = await this.$api.subAccount(id);
				if (result) {
					this.accountList = [{
						id:'',
						channel_name:"全部"
					},...result]
				}
			},
			open() {
				this.dialogVisible = true
				this.title = this.activeTabName == '0' ? '添加年龄白名单' :this.activeTabName == '1'? '添加限额白名单' :'添加充值白名单'
			},
			close(done) {
				this.resetForm()
				this.$emit('refresh')
				done && done()
				this.dialogVisible = false
			},

			/* 校验规则 */
			checkWhiteList() {
				let result = true
				let errMsg = ''
				if (this.whiteForm.id_number.length != 18) {
					result = false
					errMsg = `身份证应是18位数`
				}
				for (let key in this.whiteForm) {
					if (!this.whiteForm[key]) {
						result = false
						errMsg = `请填写必填项`
					}
				}
				if (!result) {
					this.$message({
						message: errMsg,
						type: 'warning'
					});
				}
				return result
			},
			async addWhiteList() {
				let result = true;
				/* 限额 没有type */
				if (this.activeTabName == '1') {
					delete this.whiteForm?.type
					result = this.checkWhiteList()
				} else if (this.activeTabName == '0') {
					/* 是否全公司白名单  */
					if (this.whiteForm.type == '1') {
						if (this.whiteForm.company_id == '') {
							return this.$message({
								message: `公司名称不能为空`,
								type: 'warning'
							});
						}
					} else {
						result = this.checkWhiteList()
					}
				} else {
					if (this.whiteForm.company_id == '') {
						return this.$message({
							message: `公司名称不能为空`,
							type: 'warning'
						});
					}
				}
				if (!result) {
					return
				}
				let res = null
				if (this.activeTabName == '0') {
					let whiteForm = this.whiteForm;
					if(whiteForm.channel_account){
						whiteForm.type = this.whiteForm.type =='1' ? '2' : this.whiteForm.type =='0' ? '3' : this.whiteForm.type 
					}
					res = await this.$api.postCreateAgewhite(whiteForm)
				} else if (this.activeTabName == '1') {
					res = await this.$api.postCreateQuotawhite(this.whiteForm)
				}else{
					res = await this.$api.addrechargewhiteList({company_id:this.whiteForm.company_id})
				}

				if (res) {
					this.$message({
						message: `添加成功`,
						type: 'success'
					});
					this.close()
				}
			},
			// 搜索
			handleSelect(value) {
				this.whiteForm.company_id = value?.id
				if(value?.id){
					this.accountList = [];
					this.subAccount(value?.id)
				}
			},
			resetForm() {
				this.whiteForm = {
					fullname: '',
					id_number: '',
					company_id: '',
					type: '0'
				}
				if (this.$refs.ref_tz_autocomplete) {
					this.$refs.ref_tz_autocomplete.state = ''
				}

			}
		},
		mounted() {

		},
	}
</script>

<style lang="scss" scoped>
	/deep/ .el-autocomplete {
		width: 100%;
	}
	/deep/ .el-select {
		width: 100%;
	}
</style>
